import {
  COMMENT_TOOLTIP_NAME_SHARP,
  COMMENT_TOOLTIP_NAME_MARK,
  COMMENT_TOOLTIP_NAME_FONTSIZE,
  FW_MOBILE_TOOLTIP_NAME_SELECT_COLOR_OR_CANCEL
} from '../ui/constants/comments.tooltip.constants'
import { TEXT_MARKUP_MORE_COLOR, UPDATE_MARKUP_MORE_COLOR } from 'Constants/app.constant'
import { colorConvertor } from './color.utils'
import { isMobile, /* hasClass, */ storageGetItem, storageSetItem } from 'Utils/utils'
import { store } from 'Store/store.index'
import { collaborationAnnotEvent } from 'Store/services/index'
import { getHeaderAnnot } from '@/utils/sdk_utils'

// activeAnnotation
let _selectedAnnot = null;
window.__selectedAnnot__ = _selectedAnnot;

const _propertiesMap = {
  borderWidth: 'borderWidth',
  borderStyle: 'borderStyle',
  highlightingMode: 'highlightingMode',
  rotation: 'rotation',
  lineStartStyle: 'lineStartStyle',
  lineEndStyle: 'lineEndStyle',
  opacity: 'opacity',
  color: 'color',
  fillColor: 'fillColor',
  applyFillColor: 'applyFillColor',
  font: 'font',
  hasCap: 'hasCap',
  fontColor: 'fontColor',
  fontSize: 'fontSize',
};

const tooltipNames = [
  "fv--annot-selection-sharp-tooltip",
  "fv--annot-selection-mark-tooltip"
];


export default class AnnotationStateHandler {
  constructor(pdfui, fileController) {
    this.pdfui = pdfui;
    this.fileController = fileController;
    this.selectedAnnotRender = null;

    this.fwAnnotRender = null;
    this.nowShowName = "";

    this.getComponentName = this.getComponentName.bind(this);
    this.updateComponentProperty = this.updateComponentProperty.bind(this);
    this.setBorderStyle = this.setBorderStyle.bind(this);

    this.cleanAnnotRender = this.cleanAnnotRender.bind(this);
    this.setAnnotRender = this.setAnnotRender.bind(this);
    this.bindAnnotSelectionState = this.bindAnnotSelectionState.bind(this);
    this.onClickAnnotSelectionTooltip = this.onClickAnnotSelectionTooltip.bind(this);
    this.showColorPicker = this.showColorPicker.bind(this);
    this.onUpdateComponentColor = this.onUpdateComponentColor.bind(this);

    this.fwShowTooltip = this.fwShowTooltip.bind(this);
    this.fwHideTooltip = this.fwHideTooltip.bind(this);

    store.appStore.addAppEventListener(UPDATE_MARKUP_MORE_COLOR, this.onUpdateComponentColor)
  }
  getComponentName(annotRender) {
    // highlight squiggly strikeOut underline caret => text markup
    // line polyLine polygon circle square => sharp
    // freeText=>typewriter
    let type;
      if (!annotRender || !annotRender.annot) {
        return ''
      }
      type = annotRender.annot.getType();


    let Annot_Type = window.UIExtension.PDFViewCtrl.PDF.annots.constant.Annot_Type;
    //Annot_Type.caret;
    let name = ''
    switch (type) {
      case Annot_Type.highlight:
      case Annot_Type.squiggly:
      case Annot_Type.strikeOut:
      case Annot_Type.underline:
      case Annot_Type.caret:
        // TODO FOXIT 原本为直接展示颜色选取框，修改为展示选择颜色或者取消的弹框
        if(isMobile()) {
          if(this.nowShowName && this.nowShowName === "fv--annot-selection-mark-tooltip") {
            name = COMMENT_TOOLTIP_NAME_MARK;
          } else {
            name = FW_MOBILE_TOOLTIP_NAME_SELECT_COLOR_OR_CANCEL
          }
        } else {
          name = COMMENT_TOOLTIP_NAME_MARK;
        }
        break;
      case Annot_Type.line:
      case Annot_Type.polyLine:
      case Annot_Type.polygon:
      case Annot_Type.circle:
      case Annot_Type.square:
        name = COMMENT_TOOLTIP_NAME_SHARP;
        break;
      case Annot_Type.freeText:
        if (annotRender.annot.getIntent() === "FreeTextTypewriter") {
          name = COMMENT_TOOLTIP_NAME_FONTSIZE;
        }
      default:
        break;
    }
    return name;
  }
  getComponentName_annot(annot) {
    // highlight squiggly strikeOut underline caret => text markup
    // line polyLine polygon circle square => sharp
    // freeText=>typewriter
    if (!annot) {
      return ''
    }
    let type = annot.type && annot.getType();

    let Annot_Type = window.UIExtension.PDFViewCtrl.PDF.annots.constant.Annot_Type;
    //Annot_Type.caret;
    let name = ''
    switch (type) {
      case Annot_Type.highlight:
      case Annot_Type.squiggly:
      case Annot_Type.strikeOut:
      case Annot_Type.underline:
      case Annot_Type.caret:
        // TODO FOXIT 原本为直接展示颜色选取框，修改为展示选择颜色或者取消的弹框
        if(isMobile()) {
          if(this.nowShowName && this.nowShowName === "fv--annot-selection-mark-tooltip") {
            name = COMMENT_TOOLTIP_NAME_MARK;
          } else {
            name = FW_MOBILE_TOOLTIP_NAME_SELECT_COLOR_OR_CANCEL
          }
        } else {
          name = COMMENT_TOOLTIP_NAME_MARK;
        }
        break;
      case Annot_Type.line:
      case Annot_Type.polyLine:
      case Annot_Type.polygon:
      case Annot_Type.circle:
      case Annot_Type.square:
        name = COMMENT_TOOLTIP_NAME_SHARP;
        break;
      case Annot_Type.freeText:
        if (annotRender.annot.getIntent() === "FreeTextTypewriter") {
          name = COMMENT_TOOLTIP_NAME_FONTSIZE;
        }
      default:
        break;
    }
    return name;
  }
  updateComponentProperty(component, type, propertyName, value) {
    switch (propertyName) {
      case _propertiesMap.borderWidth:
        return type == 'w' &&
          component.setBorderWidth &&
          component.setBorderWidth(value, false);
      case _propertiesMap.opacity:
        return type == 'w' &&
          component.setOpacity &&
          component.setOpacity(value / 100, false);
      case _propertiesMap.borderStyle: {
        return type == 'w' &&
          component.setBorderStyle &&
          this.setBorderStyle(component, value);
      }
      case _propertiesMap.highlightingMode:
        return type == 'w' &&
          component.setHighlightingMode &&
          component.setHighlightingMode(value);
      case _propertiesMap.rotation:
        return type == 'w' &&
          component.setRotation &&
          component.setRotation(value * 90);
      case _propertiesMap.lineEndStyle:
        return type == 'w' &&
          component.setEndingStyle &&
          component.setEndingStyle(false, value);
      case _propertiesMap.lineStartStyle:
        return type == 'w' &&
          component.setEndingStyle &&
          component.setEndingStyle(true, value);
      case _propertiesMap.color:
        if (type == 'w' && component.setColor) {
          let intValue = value === 0 ? 0 : colorConvertor(value, 'int', 1);
          return component.setColor(intValue);
        }
        break;
      case _propertiesMap.fillColor:
        if (type == 'w' && component.setFillColor) {
          return component.setFillColor(
            value === 0 ? 0 : colorConvertor(value, 'int', 1)
          );
        }
        break;
      case _propertiesMap.applyFillColor:
        if (type == 'w' && component.setApplyFillColor) {
          return component.setApplyFillColor(
            value === 0 ? 0 : colorConvertor(value, 'int', 1)
          );
        }
        break;
      case _propertiesMap.hasCap:
        return type == 'w' &&
          component.enableCaption &&
          component.enableCaption(value);
      case _propertiesMap.fontColor:
      case _propertiesMap.fontSize:
        return type == 'w' &&
          component.setDefaultAppearance &&
          component.setDefaultAppearance(propertyName.replace('font', 'text'), value);
    }
  }
  setBorderStyle(target, styleValue) {
    let newDashPattern, style = 1;
    switch (styleValue + '') {
      case '0':
        newDashPattern = [];
        style = 0;
        break;
      case '1':
        newDashPattern = [2, 2, 2, 2];
        break;
      case '2':
        newDashPattern = [3, 3, 3, 3];
        break;
      case '3':
        newDashPattern = [4, 4, 4, 4];
        break;
      case '4':
        newDashPattern = [4, 3, 2, 3];
        break;
      case '5':
        newDashPattern = [8, 4, 4, 4];
        break;
      case '6':
        newDashPattern = [4, 3, 16, 3];
        break;
      case '7':
        newDashPattern = 1;
        style = 5;
        break;
      case '8':
        newDashPattern = 2;
        style = 5;
        break;
    }
    target.setBorderStyle(style, newDashPattern);
  }

  // 显示调色盘
  showColorPicker(annotColor) {
    let $$ = window.UIExtension.jQuery;
    let nodeParent = $$(`#pdf-ui [name='fv--annot-selection-mark-tooltip'], #pdf-ui [name="fv--annot-selection-sharp-tooltip"]`);
    if (!nodeParent || !nodeParent[0]) {
      return;
    }
    /* let xButton = $$(`#pdf-ui [name="comment-markup-color-5"]`);
    if(!xButton[0]){
      xButton = $$(`#pdf-ui [name="comment-sharp-color-5"]`);
    }
    let color = xButton.attr('clr-value'); */
    let rc = nodeParent[0].getBoundingClientRect()
    let left = rc.left;
    let top = rc.top;//.offset().top;
    let width = nodeParent.width();
    let height = nodeParent.height();
    store.appStore.emitEvent(TEXT_MARKUP_MORE_COLOR, { top, left, width, height, color:annotColor });
    return;
  }

  updateCustomColorUI(color) {
    let $$ = window.UIExtension.jQuery;
    // name="fv--annot-selection-mark-tooltip" fv--annot-selection-sharp-tooltip

    let tooltip = $$(`#pdf-ui [name="fv--annot-selection-mark-tooltip"], #pdf-ui [name="fv--annot-selection-sharp-tooltip"]`);
    if (!tooltip || tooltip.length === 0) {
      return;
    }
    let name = tooltip.attr('name');
    if (name === 'fv--annot-selection-mark-tooltip') {
      let icon = $$(`#pdf-ui [name="comment-markup-color-5"] .fv__icon-popup-custom-color`);
      let xButton = $$(`#pdf-ui [name="comment-markup-color-5"]`);
      if (icon.children().length === 0) {
        let ele = $$('<span></span>')
        icon.append(ele)
      }
      xButton.attr('clr-value', color);
      icon.removeClass('fv__icon-popup-color-circle');
      icon.children().css("background-color", color);
    } else if (name === 'fv--annot-selection-sharp-tooltip') {
      //comment-sharp-color-5
      let xButton = $$(`#pdf-ui [name="comment-sharp-color-5"]`);
      xButton.attr('clr-value', color);
      let icon = $$(`#pdf-ui [name="comment-sharp-color-5"] .fv__icon-popup-custom-color`);
      //icon.removeClass('fv__icon-popup-color-circle');
      icon.css("border-color", color);
    }

  }

  onUpdateComponentColor({ color } = {}) {
    this.updateCustomColorUI(color);
    storageSetItem(localStorage, 'annot-custom-color', color)

    let component = this.selectedAnnotRender.getComponent();
    if (!component) {
      return;
    }

    this.updateComponentProperty(component, 'w', 'color', color)
  }

  // TODO FOXIT 点击按钮修改：添加选择颜色按钮和删除样式按钮操作
  onClickAnnotSelectionTooltip({ btnName }) {
    if (!this.selectedAnnotRender) {
      return;
    }
    let $$ = window.UIExtension.jQuery;
    let node = $$(`#pdf-ui [name='${btnName}']`);
    let nodes = $$(`#pdf-ui .fw--ui-annotation-selection-markup .fv__ui-layer-inner > button`);
    let clrValue = node.attr('clr-value');
    nodes.length>0 && nodes.map((index, item) => {
      item.removeClass("active")
    })
    // TODO FOXIT 选中后添加active样式
    node.addClass("active")
    let component = this.selectedAnnotRender.getComponent();
    // TODO FOXIT 选择颜色按钮：隐藏当前弹框显示，显示颜色选择框
    if (btnName === "fw--comment-button-color") {
      // this.fwHideTooltip()
      this.fwShowTooltip(this.selectedAnnotRender)
      setTimeout(() => {
        this.fwHideTooltip()
      })
      return
    }
    // TODO FOXIT 删除注释：删除当前注释内容，隐藏弹框
    if (btnName === "fw--comment-button-cancel") {
      this.selectedAnnotRender.component.removeAnnot();
      this.fwHideTooltip()
      return
    }
    //fv--annot-selection-mark-tooltip
    // click teams more to open right panel
    if (btnName === "comment-sharp-color-more-teams") {
      window.pdfui.getComponentByName('sidebar-right').then(rightPanel => {
          rightPanel && rightPanel.show();
          this.hideTooltip()
      });
      return;
    }
    if (btnName === "comment-markup-color-more" || btnName === "comment-sharp-color-more") {
      //markup component.annot..getBorderColor() , sharp
      let clr = colorConvertor(component.annot.getBorderColor(), '#', 1)
      this.showColorPicker(clr);
      return;
    }
    if (btnName.indexOf('comment-sharp') !== -1) {
      this.updateComponentProperty(component, 'w', 'color', clrValue)
    } else if (btnName.indexOf('comment-markup') !== -1) {

      this.updateComponentProperty(component, 'w', 'color', clrValue);

      const annot = component.annot;
      const type = annot.getType();

      let intent = annot.getIntent();
      if(type!=="line"&&annot.getMeasureRatio){
        intent ="";
      }
      this.pdfui.setAnnotDefaultProperty(
        type,
        intent || '',
        {color:parseInt(clrValue.substr(1),16)}
      );
    } else if (btnName.indexOf('comment-typewriter') !== -1) {
      let oldDA = component.annot.getDefaultAppearance();
      const { textSize } = oldDA;
      if (textSize === void 0) return;

      clrValue = parseInt(clrValue);
      let fontSize = textSize + clrValue;
      //6 to 40.
      if (fontSize > 40 || fontSize < 6) return;

      this.updateComponentProperty(component, 'w', 'fontSize', fontSize)
    }
  }

  cleanAnnotRender() {
    window.__selectedAnnot__ = this.selectedAnnotRender = null;
  }
  setAnnotRender(annotRender) {
    window.__selectedAnnot__ = this.selectedAnnotRender = annotRender;
  }

  bindAnnotSelectionState(pdfui, Events) {
    //return;//need webpdfsdk 7.3
    let _this = this;
    // show
    const showTooltip = async (annotRender) => {
      if (!annotRender) {
        return;
      }
      let name = this.getComponentName(annotRender);
      if(annotRender.annot.info.type === "caret" || (annotRender.annot.info.type === "strikeout" && annotRender.annot.info.typeAlias === "Replace")) {
        return
      }
      if (!name) {
        return;
      }
      // TODO FOXIT 当name为选择或删除颜色注释，存储当前的annotRender
      // if(name === "fw--annot-selection-color-or-cancel-tooltip") {
      //   _this.fwAnnotRender = annotRender
      // }
      pdfui.getComponentByName(name)
      .then(tooltip=>{
        pdfui.getGroupCount()
        .then(([gc,sc])=>{

          const allEle = pdfui.pdfViewer.getAllActivatedElements();

          const annot = allEle[0].annot;
          if(annot.isReplace&&(!annot.isReplace())||gc!==1){
            if(gc||sc>1){
              tooltip.hide();
              return
            }
          }
          _this.setAnnotRender(annotRender);
          let pageRender = annotRender.parent().parent();
          if (!pageRender) {
            return
          }
          let tooltipWidth = tooltipNames.includes(name)? 226: 152;
          let tooltipHeight = 50;
          if (isMobile()) {
            tooltipWidth = tooltipNames.includes(name)? 268: 182;
            tooltipHeight = 80;
          }
          let $$ = window.UIExtension.jQuery;
          let $tooltip = $$(`#pdf-ui [name="${name}"]`);
          if ($tooltip[0]) {
            tooltipWidth = $tooltip.outerWidth();// 152
            tooltipHeight = $tooltip.outerHeight() + 10;// 50
          }
          let pageIndex = pageRender.index;
          let rc = annotRender.annot.getRect()
          _this.fileController.transformRectArray([rc], pageIndex)
          .then(rects=>{
            let x = (rects[0].left + rects[0].right - tooltipWidth) / 2;
            let y = rects[0].top - 60 - 10;
            if (isMobile()) {
              y = y - 10;
            }
            const tooltipHalfWidth = tooltipWidth / 2
            const rectWidth = rects[0].right - rects[0].left
            const rectHalfWidth = rectWidth / 2
            const pageContainerElement = document.querySelector('.fv__pdf-page-container')
            const pageContainerElementRect = pageContainerElement.getBoundingClientRect()
            const pageWidth = pageContainerElementRect.right - pageContainerElementRect.left
            const pageHeight = pageContainerElementRect.bottom - pageContainerElementRect.top
            const middleX = rects[0].right - rectHalfWidth
            const toolTipRight = middleX + tooltipHalfWidth
      
            tooltip.element.classList.remove('show-top-side')
            tooltip.element.classList.remove('show-bottom-side')
            tooltip.element.classList.remove('show-right-side')
            tooltip.element.classList.remove('show-left-side')
            tooltip.element.classList.remove('hide-arrow')

            // is over page width
            if (toolTipRight > pageWidth) {
              x = pageWidth - (tooltipWidth + 10)
              //y = rects[0].top - tooltipHeight;
              tooltip.element.classList.add('show-left-side')
            } else if (x < 0) {
              x = 20; ///* rects[0].right + */ 20;
              //y = (rects[0].top - tooltipHeight - 10)
              tooltip.element.classList.add('show-right-side')
            }
            if (y < 0) {
              y = rects[0].bottom + 20
              tooltip.element.classList.add('show-bottom-side');
            }
            if (pageHeight - rects[0].top < tooltipHeight) {
              y = rects[0].top - tooltipHeight - 20
              tooltip.element.classList.add('show-top-side')
            }
            //(rects[0].bottom < tooltipHeight || pageHeight - rects[0].top < tooltipHeight) && (hasClass(tooltip.element, 'show-left-side') || hasClass(tooltip.element, 'show-right-side'))
            if (isMobile()) {
              tooltip.element.classList.add('hide-arrow')
            }
            //tooltip.hide();
            //tooltip.isVisible = false;
            tooltip.showAt(x, y, annotRender.$page.get(0));
            //console.log('===>>> ~ AnnotationStateHandler ~ showTooltip ~ {x, y, tooltipWidth, tooltipHeight}', { x, y, tooltipWidth, tooltipHeight });
      
            let customColor = storageGetItem(localStorage, 'annot-custom-color');
            customColor && this.updateCustomColorUI(customColor);
          })
        });
      });
    };
    // hide
    const hideTooltip = () => {
      _this.cleanAnnotRender();
      [FW_MOBILE_TOOLTIP_NAME_SELECT_COLOR_OR_CANCEL,
        COMMENT_TOOLTIP_NAME_MARK,
        COMMENT_TOOLTIP_NAME_SHARP,
        COMMENT_TOOLTIP_NAME_FONTSIZE].forEach(
          name=>pdfui.getComponentByName(name).then((tooltip) => {
            tooltip.hide();
            _this.nowShowName = ""
          })
        )
      
    }
    const DataEvents = UIExtension.PDFViewCtrl.PDF.DataEvents;
    // event
    pdfui.addViewerEventListener(Events.activeAnnotation, function (annotRender) {
      pdfui.getPDFViewer().then(viewer => {
        const docRender = viewer.getPDFDocRender();
        const isAnnotMarkup = annotRender.annot.isMarkup();
        const hasAnnotFormPermission = docRender.getUserPermission().checkAnnotForm();
        const hasModifyPermission = docRender.getUserPermission().checkModify();
        const allEle = viewer.getAllActivatedElements();

        if (allEle.length>1&&!allEle[0].annot.isReplace()||annotRender.component.propertyDisabled()||!hasAnnotFormPermission || !hasModifyPermission || !isAnnotMarkup) {
          hideTooltip(annotRender);
          return;
        }
        
        const headerAnnot = getHeaderAnnot(annotRender.annot);
        if (store.appStore.isCollaborationMode() && !_this.isAnnotOwner({ annot: headerAnnot })) {
          hideTooltip(annotRender);
          return
        }
        // TODO FOXIT 选中后添加active样式
        let activeColor = _this.getColor(annotRender.annot.info.color)
        let $$ = window.UIExtension.jQuery;
        let nodes = $$(`#pdf-ui .fw--ui-annotation-selection-markup .fv__ui-layer-inner > button`);
        nodes && nodes.map((index, item) => {
          item.removeClass("active")
          let value = item.attributes["clr-value"].value
          if(value === activeColor) {
            item.addClass("active")
          }
        })
        showTooltip(annotRender);
      })
    });
    pdfui.addViewerEventListener(Events.renderPageSuccess, function (/* _pageRender */) {
      let selectedAnnot
      // if (store.appStore.isCollaborationMode()) {
      //   selectedAnnot = store.collaborationStore.activeAnnot
      // } else {
        selectedAnnot = _this.selectedAnnotRender
      // }
      showTooltip(selectedAnnot);
    });
    pdfui.addViewerEventListener(DataEvents.annotationUpdated, function (/* annotRender */) {
      const annotRender = _this.selectedAnnotRender;
      if(!annotRender||annotRender.component.propertyDisabled()){
        hideTooltip();
        return;
      }
      showTooltip(annotRender);
    });
    pdfui.addViewerEventListener(Events.unActiveAnnotation, function (annotRender) {
      if(!annotRender){
        return
      }
      const headerAnnot = getHeaderAnnot(annotRender.annot);
      if (store.appStore.isCollaborationMode() && !_this.isAnnotOwner({ annot: headerAnnot })) {
        return
      }
      hideTooltip(annotRender);
      pdfui.getGroupCount()
      .then(groups=>{
        if(!groups[0]&&groups[1]==1){
          const annot = groups[2]["-1"][0];

          if (annot.parent) {
            const parentAnnotRender = annot.parent()

            if (!_this.isAnnotOwner({ annot: parentAnnotRender.annot })) {
              return
            }
            
            return showTooltip(parentAnnotRender)
          }
        }

        hideTooltip(annotRender);
      })
    });
    pdfui.addViewerEventListener(Events.annotationRemoved, function (annots) {
      const annot = collaborationAnnotEvent.getHeaderAndOriginAnnot(annots)
      // hideTooltip(annots[annots.length-1]);
      hideTooltip(annot);
    });
    pdfui.addViewerEventListener(Events.removeActionAnnotationBefore, function (annotRender) {
      const headerAnnot = getHeaderAnnot(annotRender.annot)

      if (store.appStore.isCollaborationMode() && !_this.isAnnotOwner({ annot: headerAnnot })) {
        return
      }

      hideTooltip(annotRender);
    });
    pdfui.addViewerEventListener(Events.switchStateHandler, function () {
      hideTooltip(_this.selectedAnnotRender);
    });
    pdfui.addViewerEventListener(Events.beforeOpenFile, function () {
      _this.cleanAnnotRender();
    });
    pdfui.addViewerEventListener("editingFreeText", function () {
      hideTooltip(_this.selectedAnnotRender);
    });
    pdfui.addViewerEventListener(Events.changeViewModeSuccess, function () {
      hideTooltip(_this.selectedAnnotRender);
    });
    pdfui.addViewerEventListener(Events.moveAnnotsToPages, function (srcPage, targetPage, annotInfo) {
      Object.keys(annotInfo).forEach(annotId => {
        pdfui.getAnnotRender(targetPage.getIndex(), annotId).then(annotRender => {
          annotRender && hideTooltip(annotRender);
        });
      });
    })
  }
  
  isAnnotOwner(annotRender) {
    const annot = annotRender.annot
    const annotObj = annot.exportToJSON()
    const annotName = annotObj.name
    if (store.collaborationStore.isAnnotOwner(annotName)) {
      return true
    } else {
      return false
    }
  }
  async fwShowTooltip(annotRender) {
    let _this = this
    if (!annotRender) {
      return;
    }
    let name = "fv--annot-selection-mark-tooltip"
    _this.nowShowName = name
    this.pdfui.getComponentByName(name)
    .then(tooltip=>{
      this.pdfui.getGroupCount()
      .then(([gc,sc])=>{
        if(gc||sc>1){
          tooltip.hide();
          return
        }
        _this.setAnnotRender(annotRender);
        let pageRender = annotRender.parent().parent();
        if (!pageRender) {
          return
        }
        let tooltipWidth = tooltipNames.includes(name)? 226: 152;
        let tooltipHeight = 50;
        if (isMobile()) {
          tooltipWidth = tooltipNames.includes(name)? 268: 182;
          tooltipHeight = 80;
        }
        let $$ = window.UIExtension.jQuery;
        let $tooltip = $$(`#pdf-ui [name="${name}"]`);
        if ($tooltip[0]) {
          tooltipWidth = $tooltip.outerWidth();// 152
          tooltipHeight = $tooltip.outerHeight() + 10;// 50
        }
  
        let pageIndex = pageRender.index;
        let rc = annotRender.annot.getRect()
        _this.fileController.transformRectArray([rc], pageIndex)
        .then(rects=>{
          let x = (rects[0].left + rects[0].right - tooltipWidth) / 2;
          let y = rects[0].top - 60 - 10;
          if (isMobile()) {
            y = y - 10;
          }
          const tooltipHalfWidth = tooltipWidth / 2
          const rectWidth = rects[0].right - rects[0].left
          const rectHalfWidth = rectWidth / 2
          const pageContainerElement = document.querySelector('.fv__pdf-page-container')
          const pageContainerElementRect = pageContainerElement.getBoundingClientRect()
          const pageWidth = pageContainerElementRect.right - pageContainerElementRect.left
          const pageHeight = pageContainerElementRect.bottom - pageContainerElementRect.top
          const middleX = rects[0].right - rectHalfWidth
          const toolTipRight = middleX + tooltipHalfWidth
    
          tooltip.element.classList.remove('show-top-side')
          tooltip.element.classList.remove('show-bottom-side')
          tooltip.element.classList.remove('show-right-side')
          tooltip.element.classList.remove('show-left-side')
          tooltip.element.classList.remove('hide-arrow')
    
          // is over page width
          if (toolTipRight > pageWidth) {
            x = pageWidth - (tooltipWidth + 10)
            //y = rects[0].top - tooltipHeight;
            tooltip.element.classList.add('show-left-side')
          } else if (x < 0) {
            x = 20; ///* rects[0].right + */ 20;
            //y = (rects[0].top - tooltipHeight - 10)
            tooltip.element.classList.add('show-right-side')
          }
          if (y < 0) {
            y = rects[0].bottom + 20
            tooltip.element.classList.add('show-bottom-side');
          }
          if (pageHeight - rects[0].top < tooltipHeight) {
            y = rects[0].top - tooltipHeight - 20
            tooltip.element.classList.add('show-top-side')
          }
          //(rects[0].bottom < tooltipHeight || pageHeight - rects[0].top < tooltipHeight) && (hasClass(tooltip.element, 'show-left-side') || hasClass(tooltip.element, 'show-right-side'))
          if (isMobile()) {
            tooltip.element.classList.add('hide-arrow')
          }
          //tooltip.hide();
          //tooltip.isVisible = false;
          tooltip.showAt(x, y, annotRender.$page.get(0));
          //console.log('===>>> ~ AnnotationStateHandler ~ showTooltip ~ {x, y, tooltipWidth, tooltipHeight}', { x, y, tooltipWidth, tooltipHeight });
    
          let customColor = storageGetItem(localStorage, 'annot-custom-color');
          customColor && this.updateCustomColorUI(customColor);
          // TODO FOXIT 选中后添加active样式
          let activeColor = _this.getColor(annotRender.annot.info.color)
          let $$ = window.UIExtension.jQuery;
          let nodes = $$(`#pdf-ui .fw--ui-annotation-selection-markup .fv__ui-layer-inner > button`);
          nodes.map((index, item) => {
            item.removeClass("active")
            let value = item.attributes["clr-value"].value
            if(value === activeColor) {
              item.addClass("active")
            }
          })
        })
      });
    });
  }
  getColor(color) {
    switch(color) {
      case 16776960:
        return "#FFFF00";
      case 5615871:
        return "#55B0FF";
      case 2678930:
        return "#28E092";
      case 15027466:
        return "#E54D0A";
      case 6579697:
        return "#6465F1";
    }
  }
  fwHideTooltip() {
    // let _this = this
    // _this.cleanAnnotRender();
    [FW_MOBILE_TOOLTIP_NAME_SELECT_COLOR_OR_CANCEL].forEach(
        name=>pdfui.getComponentByName(name).then((tooltip) => {
          tooltip.hide();
        })
      )
  }
  hideTooltip () {
    const pdfui = this.pdfui;
    this.cleanAnnotRender();
    [
      COMMENT_TOOLTIP_NAME_MARK,
      COMMENT_TOOLTIP_NAME_SHARP,
      COMMENT_TOOLTIP_NAME_FONTSIZE
    ].forEach(
      name=>pdfui.getComponentByName(name).then((tooltip) => {
        tooltip.hide();
      })
    )
  }
}

